import { useRef } from 'react';

export function useValueRef(value) {
  const ref = useRef(null);
  ref.current = value;
  return ref;
}
